import {
  ALS,
  amnesty_international,
  AmnestyInternational,
  AqmenMedtech,
  ardex,
  ArjunNatural,
  Ascendus,
  Avatar,
  Azzite,
  b2b,
  banglorestenerschool,
  Banner,
  Banner2,
  Banner3,
  Banner4,
  Banner5,
  Beepkart,
  bharatiya,
  Bisleri,
  Blitzscale,
  bottlesForchange,
  BottlesForChange,
  browser,
  cavinkare,
  Cme,
  computer,
  Creditworks,
  Croyez,
  cyber_peace,
  Cyberpeace,
  dc,
  decreasing,
  Draup,
  Ecolibrium,
  Edwardian,
  edwardian_hotels,
  Ekincare,
  Excelr,
  F2,
  FinanceBuddha,
  Finexus,
  FlameUniversity,
  Flobiz,
  foundation_for_excellence,
  FoundationExcellence,
  goeasy,
  Gopalan2,
  Graciepoint,
  Greenpeace,
  happay,
  // heart_home_circle,
  // heroku_home_circle,
  Hirect,
  homelane,
  Homeskul,
  homeskul2,
  IGSTC,
  ira,
  keenai,
 
  Kult,
  kumarOrganic,
  laptops,
  Leaders,
  loadshare,
 
  mCaffeine,
  miles,
  nambiar,
  NationalFunding,
  native,
  nativer,
  Neemans,
  nichino,
  NorthernArc,
  nsk,
  nxtgn,
  oasis,
  ocp,
  Ondonte,
  Paras,
  Quizziz,
  ramky,
  relevel,
  Renaatus,
  renaatus_forward,
  River,
  rockland,
  SFW,
  shopdeck,
  SNN_group,
  Soliflex,
  stanley,
  stanley2,
  Swagelok,
  SwarnaMahal,
  Symega,
  Thrillophilia,
  Trevi,
  Tridasa,
  tridasa_brightening_lives,
  Twin,
  UWA,
  Vaishnavi,
  vaishnavi_group,
  Vedica,
  we_work,
  WeWork,
} from "../../helpers/constant/imageUrl";

export const SOLUTION_TABS = [
  {
    id: 1,
    text: "Deep Discovery",
  },
  {
    id: 2,
    text: "Consulting",
  },
  {
    id: 3,
    text: "System Design",
  },
  {
    id: 4,
    text: "Implementation",
  },
  {
    id: 5,
    text: "Monitoring & Roadmap",
  },
];

export const SOLUTION_CONTENT = [
  {
    img: Banner,
    title: "Deep Discovery",
    list: [
      "Existing Actors",
      "Existing Infrastructure",
      "Tools They Use or Don’t",
      "Actors Assessment for Change",
      "Current Challenges",
      "Future Goals",
    ],
  },
  {
    img: Banner2,
    title: "Consulting",
    list: [
      "Strategic Guidance",
      "Data-Driven Insights",
      "Process Optimization",
      "Innovation Partner",
      "Sustainable Results",
    ],
  },
  {
    img: Banner3,
    title: "System Design",
    list: [
      "Gap Analysis",
      "Existing vs New System Architecture",
      "Tools They Use or Don’t",
      "Actors Assessment for Change",
    ],
  },
  {
    img: Banner4,
    title: "Implementation",
    list: [
      "Development on New Model",
      "Actor Interview and Recommendation",
      "Integration of New Tools",
      "User Training & Feedback",
      "User Adoption",
      "Comprehensive/Responsive Support During & After Implementation",
    ],
  },
  {
    img: Banner5,
    title: "Monitoring & Roadmap",
    list: [
      "Observation on New Model",
      "Continuous Improvement",
      "Future Roadmap Strategy",
    ],
  },
];

export const TRUSTED_BY = [
  Cme,
  ALS,
  rockland,
  ardex,
  Vedica,
  Symega,
  Swagelok,
  Soliflex,
  F2,
  Trevi,
  Ecolibrium,
  FinanceBuddha,
  happay,
  Flobiz,
  Azzite,
  Finexus,
  Quizziz,
  Excelr,
  Homeskul,
  banglorestenerschool,
  miles,
  relevel,
  FlameUniversity,
  UWA,
  Gopalan2,
  homelane,
  stanley2,
  dc,
  Bisleri,
  Kult,
  mCaffeine,
  cavinkare,
  SwarnaMahal,
  Beepkart,
  River
 
];

export const TRUSTED_BY_REVERSE = [
  shopdeck,
  ocp,
  nxtgn,
  nsk,
  nichino,
  nativer,
  loadshare,
  keenai,
  ira,
  Greenpeace,
  Draup,
  Blitzscale,
  bharatiya,
  b2b,
  Neemans,
  Croyez,
  Renaatus,
  ramky,
  Vaishnavi,
  we_work,
  tridasa_brightening_lives,
  SNN_group,
  nambiar,
  Thrillophilia,
  Edwardian,
  goeasy,
  Graciepoint,
  Creditworks,
  Ascendus,
  NorthernArc,
  NationalFunding,
  SFW,
  Hirect,
  Ondonte,
  Leaders,
  AqmenMedtech,
  Ekincare,
  kumarOrganic,
  Paras,
  Twin,
  oasis,
  ArjunNatural,
  Cyberpeace,
  FoundationExcellence,
  BottlesForChange,
  AmnestyInternational,
  IGSTC,
];



export const PROVIDE_SOLUTION_TABS = [
  {
    text: "Manufacturing",
  },
  {
    text: "Fintech",
  },
  {
    text: "EdTech",
  },
  {
    text: "Non Profit",
  },
  {
    text: "Healthcare  & Pharma",
  },
  {
    text: "Recruitment & Staffing",
  },
  {
    text: "Banking & Finance",
  },
  {
    text: "Tourism & Hospitality",
  },
  {
    text: "Visa & Immigration",
  },
  {
    text: "Retail & Consumer Goods",
  },
  {
    text: "Real Estate",
  },
  {
    text: "Automotive",
  },
];

export const RANGE_OF_INDUSTRIES = [
  {
    industry: "Manufacturing",
    img_list: [Symega, Swagelok, Cme, Soliflex, Trevi, ALS, F2, Ecolibrium],
  },
  {
    industry: "Fintech",
    img_list: [Flobiz, FinanceBuddha, Azzite, Finexus],
  },
  {
    industry: "EdTech",
    img_list: [Quizziz, Excelr, homeskul2, UWA, relevel, FlameUniversity,banglorestenerschool],
  },
  {
    industry: "Non Profit",
    img_list: [
      IGSTC,
      amnesty_international,
      bottlesForchange,
      foundation_for_excellence,
      cyber_peace,
    ],
  },
  {
    industry: "Healthcare  & Pharma",
    img_list: [ArjunNatural, oasis, Twin, Ekincare, AqmenMedtech, kumarOrganic],
  },
  {
    industry: "Recruitment & Staffing",
    img_list: [Leaders, Ondonte, Hirect],
  },
  {
    industry: "Banking & Finance",
    img_list: [
      NationalFunding,
      NorthernArc,
      Ascendus,
      Creditworks,
      Graciepoint,
      goeasy,
    ],
  },
  {
    industry: "Banking & Finance",
    img_list: [edwardian_hotels, Thrillophilia],
  },
  {
    industry: "Tourism & Hospitality",
    img_list: [Croyez],
  },
  {
    industry: "Visa & Immigration",
    img_list: [Bisleri, Kult, mCaffeine, SwarnaMahal, Neemans,Vedica],
  },
  {
    industry: "Real Estate",
    img_list: [
      tridasa_brightening_lives,
      renaatus_forward,
      vaishnavi_group,
      we_work,
      SNN_group
    ],
  },
  {
    industry: "Automotive",
    img_list: [Beepkart,River],
  },
];

export const CLIENT_SAYS = [
  {
    company_img: Excelr,
    type: "Edtech",
    desc: "ExcelR's collaboration with Utilitarian Labs in implementing Salesforce CRM has been crucial to our success, streamlining operations in both B2C and B2B domains. Their expertise in our challenging B2B vertical enhanced our sales efficiency and global training delivery, reinforcing our commitment to excellence and innovation in professional and organizational development.",
    personImg: Avatar,
    personName: "Amit Tavva",
    personRole: "Head of Digital Marketing"
  },

  {
    company_img: Hirect,
    type: "Recruitment & Staffing",
    desc: "Implementing a new CRM system was a daunting task until we partnered with Utilitarian Labs. Their team didn't just offer a solution; they transformed our entire recruitment process. The result? A 30% faster time-to-hire and vastly improved candidate satisfaction. It's clear that Utilitarian Labs prioritizes outcomes and client success above all.",
    personImg: Avatar,
    personName: "Nikshep Maknoor",
    personRole: "Product Manager"
  },
    {
    company_img: Ondonte,
    type: "Recruitment & Staffing",
    desc: "Our recruitment process was in dire need of an overhaul. The scattered candidate data and disjointed processes were holding us back. That changed dramatically after integrating the Salesforce solution provided by Utilitarian Labs. Their expertise not only streamlined our operations but also brought our team closer to our candidates. The difference is night and day. ",
    personImg: Avatar,
    personName: "Glen Melton",
    personRole: "CEO"
  },  {
    company_img: Homeskul,
    type: "Edtech",
    desc: "Utilitarian Labs' Salesforce implementation was a game-changer for HomeSkul, sealing the cracks in our lead management and supercharging our sales efficiency. Their tailored CRM solution not only plugged our lead leakages but also turbocharged our lead conversion rates, providing a seamless path from initial interest to enrolment.",
    personImg: Avatar,
    personName: "Jenson T J",
    personRole: "Head of L&D"
  },  {
    company_img: Leaders,
    type: "Recruitment & Staffing",
    desc: "The insight and personalization capabilities we've gained in our client relationships are all thanks to the Salesforce CRM implementation guided by Utilitarian Labs. Their team ensured a smooth transition, comprehensive training, and ongoing support, proving their commitment to our success every step of the way. Utilitarian Labs has truly been a partner in our digital transformation journey. ",
    personImg: Avatar,
    personName: "Richard Joly",
    personRole: "Associate Director"
  },
]

export const datas=[
  {logo:"/images/summit2.webp",
    heading:"Summit-Level Expertise ",
  },
   {logo:"/images/rocket.webp",
    heading:"100+ Projects Delivered ",
  },
   {logo:"/images/cert.webp",
    heading:"Trusted by 90+ Customers",
  },
    {logo:"/images/vt.webp",
    heading:"100% Certified Team ",
  },
    {logo:"/images/hns.webp",
    heading:"12+ Industry Specializations ",
  },
    {logo:"/images/pstar.webp",
    heading:"120+ Dedicated Experts  ",
  },
]



export const ambition=[
  {logo:"",
    heading:"Implementation & Deployment",
    desc:"Seamless rollout of Salesforce solutions tailored to your business needs."
  },
    {logo:"",
    heading:"Implementation & Deployment",
    desc:"Seamless rollout of Salesforce solutions tailored to your business needs."
  },
    {logo:"",
    heading:"Implementation & Deployment",
    desc:"Seamless rollout of Salesforce solutions tailored to your business needs."
  },
   
]



export const homedata = {
  heading: <>Our <span className="exp-bold" style={{color:"orange"}}>Technical Expertise</span> includes</>,
  arraydms: [
    {
      src: computer,
      desc: "<b>Architecture & Scalability </b> </br> Building robust, scalable systems for future growth",
    },
    {
      src: decreasing,
      desc: "<b >Security & Governance</b></br> Ensuring robust protection and regulatory adherence",
    },
    {
      src: laptops,
      desc: " <b>Data Migration & Management</b> </br>Ensuring accurate and seamless data management",
    },
    {
      src: browser,
      desc: "<b>DevOps & CI/CD </b> Accelerating development for faster, quality releases. ",
    },
  ],
};



const test = [
  {
    image: '/images/im1.webp',
    title: 'Implemented end to end Customer transactional journey (Presales, Sales, Post sales and customer portal) on Salesforce for a leading Real Estate customer based out of Hyderabad.',
  },
  {
    image: '/images/im2.webp',
    title: 'We implemented Warranty Management, Post Sales Service, spare parts & Inventory management for a leading Two-Wheeler EV manufacturer from India.',
  },
  {
    image: '/images/im3.webp',
    title: 'We implemented for a large quasi government Non-Profit organization based out of New Delhi, their entire multiyear Grants management program with multiple modules viz, Applicants module, Reviewers module and the entire Grants management module.',
  
  },
];
export default test